export class SaveFormDeclarationLocalData {
       declarationData = {
              FormType: "",
              FormSubType: "",
              ContractNummer: "",
              AccountNumber: "",
              User: 0,
              DataXML: {
                     XMLFile: {
                            Header:
                            {
                                   QualCiv: "",
                                   Nom: "",
                                   Prenom: "",
                                   NoClient: 0,
                                   RegimeLinguistique: "",
                                   Email: "",
                                   Rue: "",
                                   NoRue: "",
                                   CodePostal: 0,
                                   Localite: "",
                                   LibellePays: ""
                            },
                            Declaration: [
                                   {
                                          Comment: "",
                                          contrat: [],
                                          Exercice: 0,
                                          PeriodeDebut: Date,
                                          PeriodeFin: Date,
                                          NoDeclaration: 0,
                                          NoProgressif: 0,
                                          Genre: "",
                                          noIntervenantDestinataire: 0,
                                          NomDestinataire: "",
                                          PrenomDestinataire: "",
                                          RoleDestinataire: "",
                                          Statut: "",
                                          Libelle: "",
                                          CodeMontantBrut: "",
                                          MontantBrut: 0,
                                          CodeMontantNet: '',
                                          MontantNet: 0,
                                          CodeMontantTVA: '',
                                          MontantTVA: 0,
                                          TVAApplicable: 1,
                                          CodeActivite: "",
                                          Activite: [
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                          ],
                                          CodePourcentTot: 0,
                                          independant: [

                                          ]
                                   },
                                   {
                                          Comment: "",
                                          contrat: [],
                                          Exercice: 0,
                                          PeriodeDebut: Date,
                                          PeriodeFin: Date,
                                          NoDeclaration: 0,
                                          NoProgressif: 0,
                                          Genre: "I",
                                          noIntervenantDestinataire: 0,
                                          NomDestinataire: "",
                                          PrenomDestinataire: "",
                                          RoleDestinataire: "",
                                          Statut: "",
                                          Libelle: "",
                                          CodeMontantBrut: "",
                                          MontantBrut: 0,
                                          CodeMontantNet: '',
                                          MontantNet: 0,
                                          CodeMontantTVA: '',
                                          MontantTVA: 0,
                                          TVAApplicable: 1,
                                          CodeActivite: "",
                                          Activite: [
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                          ],
                                          CodePourcentTot: 0,
                                          independant:  {
                                                 NbrIndependantTot: "",
                                                 CodeIndependantTot: "",
                                                 NbrAidantTot: "",
                                                 CodeAidantTot: "",
                                                 signaletique: [
                                                     {
                                                    Type: "",
                                                    Nom: "",
                                                  Prenom: "",
                                                  DateNaissance: ""
                                                    }
                                                   ]
                                                 }
                                   },
                                   {
                                          Comment: "",
                                          contrat: [],
                                          Exercice: 0,
                                          PeriodeDebut: Date,
                                          PeriodeFin: Date,
                                          NoDeclaration: 0,
                                          NoProgressif: 0,
                                          Genre: "C",
                                          noIntervenantDestinataire: 0,
                                          NomDestinataire: "",
                                          PrenomDestinataire: "",
                                          RoleDestinataire: "",
                                          Statut: "",
                                          independant: 
                                          {
                                                 NbrIndependantTot: "",
                                                 CodeIndependantTot: "",
                                                 NbrAidantTot: "",
                                                 CodeAidantTot: "",
                                                 signaletique: []
                                                 }
                                   },
                                  
                                   {
                                          Comment: "",
                                          contrat: [],
                                          Exercice: 0,
                                          PeriodeDebut: Date,
                                          PeriodeFin: Date,
                                          NoDeclaration: 0,
                                          NoProgressif: 0,
                                          Genre: "O",
                                          noIntervenantDestinataire: 0,
                                          NomDestinataire: "",
                                          PrenomDestinataire: "",
                                          RoleDestinataire: "",
                                          Statut: "",
                                          Libelle: "",
                                          CodeMontantBrut: "",
                                          MontantBrut: 0,
                                          CodeMontantNet: '',
                                          MontantNet: 0,
                                          CodeMontantTVA: '',
                                          MontantTVA: 0,
                                          TVAApplicable: 1,
                                          CodeActivite: "",
                                          Activite: [
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                          ],
                                          CodePourcentTot: 0,
                                          independant:  {
                                                 NbrIndependantTot: "",
                                                 CodeIndependantTot: "",
                                                 NbrAidantTot: "",
                                                 CodeAidantTot: "",
                                                 signaletique: [
                                                     {
                                                    Type: "",
                                                    Nom: "",
                                                  Prenom: "",
                                                  DateNaissance: ""
                                                    }
                                                   ]
                                                 }
                                   },
                                   {
                                          Comment: "",
                                          contrat: [],
                                          Exercice: 0,
                                          PeriodeDebut: Date,
                                          PeriodeFin: Date,
                                          NoDeclaration: 0,
                                          NoProgressif: 0,
                                          Genre: "T",
                                          noIntervenantDestinataire: 0,
                                          NomDestinataire: "",
                                          PrenomDestinataire: "",
                                          RoleDestinataire: "",
                                          Statut: "",
                                          Libelle: "",
                                          CodeMontantBrut: "",
                                          MontantBrut: 0,
                                          CodeMontantNet: '',
                                          MontantNet: 0,
                                          CodeMontantTVA: '',
                                          MontantTVA: 0,
                                          TVAApplicable: 1,
                                          CodeActivite: "",
                                          Activite: [
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                                 {
                                                        TVAApplicable: 0,
                                                        CodeActivite: "",
                                                        Libelle: "",
                                                        CodeMontantBrut: "ZCHAFTTOT",
                                                        CodeMontantNet: "ZCHAFTNET",
                                                        CodeMontantTVA: "ZFACTTTVA",
                                                        MontantNet: 0,
                                                        MontantTVA: 0,
                                                        MontantBrut: 0,
                                                        CodeRepartition: "",
                                                        Pourcent: 0
                                                 },
                                          ],
                                          CodePourcentTot: 0,
                                          independant: []
                                   }

                            ]
                     }
              }
       }
}
